<header>
    <label class="close_button" (click)="close()">x</label>
    <div class="header" style="display:block">
        <h1> {{heading}} </h1>
    </div>
</header>

<div class="body" [style]="errormsg||successmsg? 'margin: 1% 2% 0% 3%;':  'margin: 1% 2% 4.8% 3%;'">
    <div class="row">
        <label class="catlabel col-6">Period<span style="color:#ff0000">*</span></label>
        <select [(ngModel)]="selected_period_id" [ngModelOptions]="{standalone: true}" (change)="getTiers()"
            style="font-family:Roboto;font-size:13px" class="col-5">
            <option *ngFor="let periodItem of periodData" [value]="periodItem.periodId">
                {{periodItem.period}}
            </option>
        </select>
    </div>

    <div class="row">
        <label class="catlabel col-6">Tier<span style="color:#ff0000">*</span></label>
        <select [(ngModel)]="selected_tier_id" [ngModelOptions]="{standalone: true}"
            style="font-family:Roboto;font-size:13px" class="col-5">
            <option *ngFor="let tierItem of tierData" [value]="tierItem.tierId">
                {{tierItem.description}}
            </option>
        </select>
    </div>

    <div class="row">
        <label class="catlabel col-6">Today's Target for Tier (%)<span style="color:#ff0000">*</span></label>
        <input type="number" class="col-5" [(ngModel)]="selectedPercentage" min="0" max="100">
    </div>
</div>
<label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
<label *ngIf="successmsg" class="successmsg"> {{successmsg}} </label>
<div class="footer">
    <button (click)="onNoClick()" class="cancel"
        style="display: inline; background: transparent;border: none !important;"> CANCEL </button>
    <button mat-raised-button class="submit" style="display: inline;" (click)="saveClick()">SUBMIT</button>
</div>